export default __webpack_public_path__ + "img/logo.bda3c27e.webp";